var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1262 0.525357C12.8168 0.25704 12.3973 0.106308 11.9599 0.106308C11.5225 0.106308 11.103 0.25704 10.7936 0.525357L4.53662 5.95406V7.97784H6.86919L13.1262 2.54913C13.4355 2.28074 13.6092 1.91676 13.6092 1.53725C13.6092 1.15773 13.4355 0.793754 13.1262 0.525357Z",
    fill: "#9F9D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.84286C0 1.3541 0.213916 0.885363 0.59469 0.53976C0.975464 0.194158 1.4919 0 2.0304 0H6.0912C6.36045 0 6.61867 0.097079 6.80906 0.26988C6.99944 0.442682 7.1064 0.677051 7.1064 0.921429C7.1064 1.16581 6.99944 1.40018 6.80906 1.57298C6.61867 1.74578 6.36045 1.84286 6.0912 1.84286H2.0304V11.0571H12.1824V7.37143C12.1824 7.12705 12.2894 6.89268 12.4797 6.71988C12.6701 6.54708 12.9284 6.45 13.1976 6.45C13.4668 6.45 13.7251 6.54708 13.9155 6.71988C14.1058 6.89268 14.2128 7.12705 14.2128 7.37143V11.0571C14.2128 11.5459 13.9989 12.0146 13.6181 12.3602C13.2373 12.7058 12.7209 12.9 12.1824 12.9H2.0304C1.4919 12.9 0.975464 12.7058 0.59469 12.3602C0.213916 12.0146 0 11.5459 0 11.0571V1.84286Z",
    fill: "#9F9D9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostIcon);
export default __webpack_public_path__ + "static/media/post-icon.28f757ee74b80a15ae309fc8085c1112.svg";
export { ForwardRef as ReactComponent };